export class MessageService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Retrieve a list of all message types.
     */
    retrieveMessageTypes() {
        return this.$http.get(this.apexApiUrl + "message-types/")
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Retrieve a list of all non-archived bulletins.
     */
    retrieveBulletins() {
        return this.$http.get(this.apexApiUrl + "bulletins/", {
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Return all unacknowledged bulletins from the current user's inbox.
     * @returns {Promise<Bulletin>} The list of unacknowedged bulletins visible
     * to the current user.
     */
    retrieveBulletinInbox() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "bulletins/inbox"
        }).then(response => response.data);
    }

    /**
     * Acknowledge that the current user has read the bulletin.
     * @param {number} bulletinID The bulletin to be acknowledged
     * @param {boolean} sendEmailCopy Indicates whether the user should be emailed a copy of the bulletin
     * @returns {Promise} Resolve once the acknowledgement has been confirmed.
     */
    acknowledgeBulletin(bulletinID, sendEmailCopy) {
        return this.$http.post(this.apexApiUrl + "bulletins/inbox/" + bulletinID + "/acknowledge"
            + "?sendEmailCopy=" + sendEmailCopy);
    }

    /**
     * Retrieve data about the specific bulletin with the given ID.
     */
    retrieveBulletin(bulletinID) {
        return this.$http.get(this.apexApiUrl + "bulletins/" + bulletinID, {
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Create a new bulletin from the given bulletin object.
     * @param {Bulletin} bulletin The bulletin body to be created.
     * @returns {Promise<Bulletin>} The created bulletin contents.
     */
    createBulletin(bulletin) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "bulletins/",
            headers: {
                "Content-Type": "application/json"
            },
            data: bulletin
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Update the bulletin with the given ID.
     * @param {number} bulletinID The ID of the bulletin to be updated
     * @param {Bulletin} bulletin The updated bulletin contents
     * @returns {Promise} Resolve asynchronously once the update is complete.
     */
    updateBulletin(bulletinID, bulletin) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "bulletins/" + bulletinID,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(bulletin)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Deliver emails to all recipients of the given bulletin immediately, regardless
     * of whether they have acknowledged or already had a copy of the bulletin sent to them.
     * @param {number} bulletinID The bulletin whose recipients will be contacted.
     */
    deliverEmails(bulletinID) {
        //TODO: Make RESTful. Eg, POST to /bulletin-deliveries and return all queued messages created.
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "bulletins/" + bulletinID + "/deliver",
            headers: {
                "Content-Type": "application/json"
            },
            data: {}
        });
    }

    createMessage(message) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "messages",
            data: message
        });
    }
}
